import { render } from "./StudentList.vue?vue&type=template&id=b99692dc&scoped=true"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"

import "./StudentList.vue?vue&type=style&index=0&id=b99692dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99692dc"]])

export default __exports__